module.exports = __webpack_public_path__ + "img/part-8-title.2a4699ec.png";